function convert(duration, unit) {
    if (duration == null) {
        return;
    }

    switch (unit) {
        case "weeks":
            return `P${duration}W`;
        default:
            // days
            return `P${duration}D`;
    }
}

function parse(duration, toUnit) {
    if (!duration) {
        return;
    }

    const unit = duration.slice(-1);
    const amount = parseInt(duration.slice(1, -1), 10);

    if (isNaN(amount)) {
        return 0;
    }

    switch (unit) {
        case "W":
            return amount;
        case "D":
            return toUnit === "days" ? amount : /* weeks */ Math.round(amount / 7);
    }
}

export { convert, parse };
export default {
    convert,
    parse,
};
